import React from 'react'
import Heading from '../components/Heading'
import ResponsiveTable from '../components/ResponsiveTable'
import ModuleWithLoader from '../components/ModuleWithLoader'
import DataSource from '../DataSource'

class Documents extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isLoaded: false,
            hasError: false,
            myDocuments: {
                headings: [],
                rows: []
            }
        }
    }

    componentDidMount () {
        DataSource.getData(`/api/getMyDocuments/${this.props.type}/${this.props.serviceId}`, result => {
            this.setState(result)
            this.setState({ isLoaded: true })
        }, () => {
            this.setState({ hasError: true, isLoaded: true })
        })
    }

    render () {
	    const NoDocs = <p className='text-center'>There are currently no documents available.</p>

        return (
            <div className='service-documents module'>
                <Heading title={this.props.title} />
                <ModuleWithLoader isLoaded={this.state.isLoaded} hasError={this.state.hasError} className='p-4'>
                    {this.state.myDocuments.rows.length > 0 ? <ResponsiveTable data={this.state.myDocuments} minWidthMobile={500} /> : NoDocs}
                </ModuleWithLoader>
            </div>
        )
    }
}

export default Documents



// WEBPACK FOOTER //
// ./resources/js/modules/Documents.js